import {
  Icon,
  Typography,
  getTheme,
  ifStyle,
  pxToRem,
  styled,
} from '~/modules';

const backgroundZ2 = getTheme('background.z2');
const textMain = getTheme('text.main');
const spacingXs = getTheme('spacing.xs');
const spacingMd = getTheme('spacing.md');
const brandPrimaryMain = getTheme('brand.primary.main');
const borderRadiusXl = getTheme('borderRadius.xl');
const isLast = ifStyle('$isLast');
const isFirst = ifStyle('$isFirst');

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

type InstallmentOptionProps = {
  $isLast?: boolean;
  $isFirst?: boolean;
};

export const InstallmentOption = styled.div<InstallmentOptionProps>`
  display: flex;
  justify-content: space-between;
  background-color: ${backgroundZ2};
  padding: ${spacingMd}px;
  border-top-right-radius: ${isFirst(borderRadiusXl, 0)}px;
  border-top-left-radius: ${isFirst(borderRadiusXl, 0)}px;
  border-bottom-right-radius: ${isLast(borderRadiusXl, 0)}px;
  border-bottom-left-radius: ${isLast(borderRadiusXl, 0)}px;
  border-bottom: ${isLast(0, `1px solid #1312641a`)};
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InstallmentNumber = styled(Typography)`
  font-weight: 600;
`;

export const InstallmentValue = styled(Typography)``;

export const InstallmentTotalValue = styled(Typography).attrs({
  variant: 'xs',
})`
  font-weight: 600;
  color: ${textMain};
  opacity: 0.6;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #3860e31a;
  width: ${pxToRem(40)};
  height: ${pxToRem(40)};
`;

export const IconComponent = styled(Icon).attrs({
  fontSize: pxToRem(16),
})`
  color: ${brandPrimaryMain};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacingXs}px;
`;

export const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const InstallmentTotalValueLabel = styled(Typography).attrs({
  variant: 'xs',
})`
  color: ${textMain};
  opacity: 0.6;
`;
